import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Heading,
    Text,
    Button,
    useBreakpointValue
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import {useHistory} from 'react-router-dom'
import {LeftArrow} from '../icons'

const MaintenancePage = ({title, message}) => {
    const history = useHistory()
    const isMobile = useBreakpointValue({base: true, md: false})

    return (
        <Box padding={{base: '32px 16px 40px', lg: 0}}>
            {isMobile && (
                <Button mb="32px" variant="link" onClick={() => history.push('/account')}>
                    <LeftArrow />
                </Button>
            )}

            <Heading as="h1" fontSize="24px" mb={4} textAlign="left" textTransform="uppercase">
                {title}
            </Heading>

            <Text mb={{base: '345px', lg: 10}} textAlign="left">
                {message}
            </Text>

            <Button
                variant="solid"
                colorScheme="blue"
                onClick={() => history.push('/')}
                textAlign="left"
                width={{base: '100%', lg: '343px'}}
                fontSize="md"
            >
                <FormattedMessage defaultMessage="Continue Shopping" id="maintenance_page.cta" />
            </Button>
        </Box>
    )
}

MaintenancePage.propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired
}

export default MaintenancePage
